import React from "react"

import CarButton from "components/CarButton"

const EXAMPLE_NUMBER = "5N3ZA0NE6AN906847"

function gotoVin() {
  window.location.href = `/search/${EXAMPLE_NUMBER}`
}

const SearchHistory = () => (
  <div className="SearchHistory">
    <h3>Zadnjih deset iskanih vozil</h3>
    <div className="last-ten-list">
      <div className="first-five">
        <CarButton
          onClick={gotoVin}
          make_and_model="RENAULT LAGUNA / GRANDTOUR 2.0 / DCI"
          vin={EXAMPLE_NUMBER}
          vehicle_type="car"
          owner_count={1}
        />
        <CarButton
          onClick={gotoVin}
          make_and_model="VOLKSWAGEN TIGUAN / 2.0 / TDI 4M"
          vin={EXAMPLE_NUMBER}
          vehicle_type="car"
          owner_count={3}
          is_imported
          is_anomalous
        />
        <CarButton
          onClick={gotoVin}
          make_and_model="MITSUBISHI L200 / DC / HP"
          vin={EXAMPLE_NUMBER}
          vehicle_type="truck"
          owner_count={2}
          is_imported
        />
        <CarButton
          onClick={gotoVin}
          make_and_model="ALFA ROMEO 147 / 1.9 / JTD"
          vin={EXAMPLE_NUMBER}
          vehicle_type="car"
          owner_count={1}
          is_anomalous
        />
        <CarButton
          onClick={gotoVin}
          make_and_model="SUZUKI VITARA / 1.6"
          vin={EXAMPLE_NUMBER}
          vehicle_type="car"
          owner_count={3}
        />
      </div>
      <div className="last-five">
        <CarButton
          onClick={gotoVin}
          make_and_model="SUBARU LEGACY / WAGON 2.0 / D AWD"
          vin={EXAMPLE_NUMBER}
          vehicle_type="car"
          owner_count={2}
          is_warning
        />
        <CarButton
          onClick={gotoVin}
          make_and_model="TOMOS ALPINO APN 6"
          vin={EXAMPLE_NUMBER}
          vehicle_type="bike"
          owner_count={1}
        />
        <CarButton
          onClick={gotoVin}
          make_and_model="AUDI A6 / 3.0 / TDI Q AUT."
          vin={EXAMPLE_NUMBER}
          vehicle_type="car"
          owner_count={1}
          is_anomalous
        />
        <CarButton
          onClick={gotoVin}
          make_and_model="FORD MONDEO / 1.8"
          vin={EXAMPLE_NUMBER}
          vehicle_type="car"
          owner_count={4}
          is_imported
        />
        <CarButton
          onClick={gotoVin}
          make_and_model="OPEL ASTRA / 1.2"
          vin={EXAMPLE_NUMBER}
          vehicle_type="car"
          owner_count={1}
        />
      </div>
    </div>
  </div>
)

export default SearchHistory
